import Vue from 'vue'

import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar'
import iconSet from 'quasar/icon-set/material-icons'

import {
  QLayout,
  QPageContainer,
  QPage,
  QHeader,
  QFooter,
  QDrawer,
  QPageSticky,
  QPageScroller,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QSpace,
  QForm,
  QInput,
  QSelect,
  QCheckbox,
  QItem,
  QIcon,
  QTable,
  QTh,
  QTr,
  QTd,
  QMarkupTable,
  QPopupProxy,
  ClosePopup,
  QDialog,
  QBanner,
  QChip,
  QCard,
  QCardSection,
  QCardActions,
  QScrollArea,
  QList,
  QItemSection,
  QItemLabel,
  QSeparator,
  QAvatar,
  QField,
  QDate,
  QTabs,
  QTab,
  QRouteTab,
  QLinearProgress,
  QBtnGroup,
  Loading,
  Dialog,
  Notify,
  QInnerLoading,
  QSpinner,
  QSpinnerDots,
  QTooltip
} from 'quasar'

Vue.use(Quasar, {
  config: {
    Loading: {},
    Notify: { }
  },
  iconSet: iconSet,
  components: {
    QLayout,
    QPageContainer,
    QPage,
    QHeader,
    QFooter,
    QDrawer,
    QPageSticky,
    QPageScroller,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QSpace,
    QForm,
    QInput,
    QSelect,
    QCheckbox,
    QItem,
    QIcon,
    QTable,
    QTh,
    QTr,
    QTd,
    QMarkupTable,
    QPopupProxy,
    QDialog,
    QBanner,
    QChip,
    QCard,
    QCardSection,
    QCardActions,
    QScrollArea,
    QList,
    QItemSection,
    QItemLabel,
    QSeparator,
    QAvatar,
    QField,
    QDate,
    QTabs,
    QTab,
    QRouteTab,
    QLinearProgress,
    QBtnGroup,
    QInnerLoading,
    QSpinner,
    QSpinnerDots,
    QTooltip
  },
  plugins: {
    Loading,
    Dialog,
    Notify
  },
  directives: {
    ClosePopup
  }
})

export default {

}